/**
 * Product types for licenses.
 */
export enum LicenseProductType {
  TEST = 'test',
  TEST_Z = 'dad_test_z',
  TEST_3_4 = 'test_3-4',
  TEST_4_5 = 'test_4-5',
  TEST_5_7_v2 = 'test_5-7_v2',
  APPLICATION = 'application',
  GAME = 'game',
  MANAGEMENT = 'management',
  ANALYTICS = 'analytics',
  GENERAL = 'general',
  SMART = 'smart',
  CIRIL = 'ciril',
  QUESTIONNAIRE = 'questionnaire',
  PARENTS_APP = 'parents_app',
  PAP = 'pap',
  CHILD_PORTFOLIO = 'child-portfolio',
}
